export class User {
  constructor(username: string) {
    this.username = username;
  }

  username: string;
}
